import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { FuseUtilsService } from '@fuse/services/utils';
import { environment } from 'environments/environment';
import { Subject, takeUntil } from 'rxjs';
import { ServicesSeoService } from './services-seo.service';
import { ServicesService } from './services.service';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss'],
  animations: [fuseAnimations],
})
export class ServicesComponent implements OnInit, OnDestroy {
  isScreenSmall: boolean;
  widget: any;

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private _fuseMediaWatcherService: FuseMediaWatcherService,
    private service: ServicesService,
    private _utilService: FuseUtilsService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _seoService: ServicesSeoService,
  ) {}

  ngOnInit(): void {
    this.service.items$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((rows) => {
        console.log('🚀 ~ ServicesComponent ~ .subscribe ~ rows:', rows);
        this._seoService.setService(rows);
        this.widget = rows;
      });

    // Subscribe to media changes
    this._fuseMediaWatcherService.onMediaChange$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(({ matchingAliases }) => {
        // Check if the screen is small
        this.isScreenSmall = !matchingAliases.includes('md');
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  getResponviceClasses(widgets) {
    const colClasses = this._utilService.generateResponsiveClass(
      widgets.Columns,
    );
    this._changeDetectorRef.markForCheck();
    return `${widgets.__component.replace('.', '_')} ${colClasses}`;
  }

  getImageUrl(image) {
    return `${environment.assets}${image?.attributes?.url}` || '';
  }
}
